var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"static-page-container",class:{noMargin: _vm.$route.name === 'HowToGet'}},[_c('section',{staticClass:"static-container-inner"},[_c('div',{staticClass:"page-block-container",class:{loading: _vm.$store.getters.loading.page}},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }